import { configureStore } from "@reduxjs/toolkit";

import openHousesReducer from "../slices/openHousesSlice";
import uiReducer from "../slices/uiSlice";

export default services =>
  configureStore({
    reducer: {
      open_houses: openHousesReducer,
      ui: uiReducer
    },
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        thunk: {
          extraArgument: services
        },
        serializableCheck: false
      })
  });
